import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSplitPdf = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <rect width={24} height={24} fill="#AA67FF" rx={5} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m18.002 6.074-8.57 8.519m0-5.186 8.57 8.519M16.139 12h.007m3.346 0h.008M7.569 5.333c1.235 0 2.236.995 2.236 2.222 0 1.228-1.001 2.223-2.236 2.223a2.23 2.23 0 0 1-2.236-2.223c0-1.227 1.001-2.222 2.236-2.222m0 8.89c1.235 0 2.236.994 2.236 2.221s-1.001 2.223-2.236 2.223a2.23 2.23 0 0 1-2.236-2.223c0-1.227 1.001-2.222 2.236-2.222"
    />
  </svg>
);
export default SvgSplitPdf;
